export default __webpack_public_path__ + "static/project-slide-1-768-700-64bd3a56d90532e26318d316a948aba5.jpg";